var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisionOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.485 1.1 21.9 2.516 2.808 21.607l-1.415-1.415 2.868-2.866-.028-.022C2.42 15.902 1.05 14.096 0 11.994l.383-.7C3.717 4.989 10.705 2.492 16.675 4.91zm-.718 5.596C21.58 8.098 22.95 9.904 24 12.006l-.383.7c-3.335 6.306-10.322 8.803-16.292 6.384l1.965-1.965q1.269.34 2.68.377c3.728-.093 6.672-1.736 8.918-4.867.343-.477.326-.825-.01-1.286-.722-.986-1.52-1.88-2.47-2.614-.144-.11-.297-.33-.471-.26l1.802-1.8.028.02zm-1.862 2.352c.737 4.329-2.603 8.112-6.69 7.57a5.5 5.5 0 0 1-1.143-.275l7.74-7.743c-.042.133.07.308.093.448m-12.262-.35c-1 .761-1.834 1.695-2.577 2.737-.301.423-.276.736.014 1.145q1.3 1.842 2.926 2.999l1.308-1.307c-1.054-1.42-1.553-3.319-1.21-5.271.03-.171.19-.393-.006-.514-.173-.106-.319.107-.455.211m4.112-1.556c-1.194.018-2.134 1.043-2.133 2.325 0 1.29.952 2.324 2.132 2.318l.048-.002 2.108-2.106q.01-.117.01-.24c-.01-1.265-.998-2.314-2.165-2.295"
  })));
};
export default SvgVisionOff;